import Item from './components/Item/Item'

export const SkillsList = ({
  keyBenefits = [],
}: {
  keyBenefits?: { title?: string; description?: string }[]
}) =>
  keyBenefits && (
    <ul className='container grid grid-cols-1 lg:grid-cols-4 lg:grid-rows-[auto_auto] py-3 gap-5 lg:gap-y-3'>
      {keyBenefits.map((item, i) => (
        <Item key={i} title={item.title} description={item.description} />
      ))}
    </ul>
  )
